import Vue from 'vue'
import { AclInstaller, AclCreate, AclRule } from 'vue-acl'
import router from '@/router'

Vue.use(AclInstaller)

let initialRole = 'admin'

const userInfo = JSON.parse(localStorage.getItem('userInfo'))
if (userInfo && userInfo.userRole) initialRole = userInfo.userRole

export default new AclCreate({
  initial  : initialRole,
  notfound : '/pages/not-authorized',
  router,
  acceptLocalRules : true,
  globalRules: {
    admin  : new AclRule('admin').generate(),
    editor : new AclRule('editor').or('admin').generate(),
    // 'agent' = the dedicated agent user (e.g. Qzero). Its real capabilities are
    // enforced server-side by the /api/agent/cowork/* endpoints (encode a
    // quotation, add/modify a person, add an address); it normally acts via its
    // API key, not by browsing the UI.
    agent  : new AclRule('agent').or('admin').generate()
  }
})
